export default {
  env: 'local',
  cookie: 'md-noticejs-sticky-',
  domain: 'localhost',
};



/** WEBPACK FOOTER **
 ** ./src/environments/local.js
 **/